import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminForm = () => {
  const backUrl = process.env.REACT_APP_BACK_URL;
  const [admin, setAdmin] = useState({ Email: "", Password: "" });

  // fetch admin detail
  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const res = await axios.get(`${backUrl}/admin/get-admin`);
        setAdmin(res.data);
      } catch (error) {
        console.error("Error fetching admin:", error);
      }
    };
    fetchAdmin();
  }, [backUrl]);

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdmin((prev) => ({ ...prev, [name]: value }));
  };

  // update admin
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${backUrl}/admin/edit-admin`, admin);
      alert(res.data.msg);
    } catch (error) {
      console.error("Error updating admin:", error);
      alert("Update failed");
    }
  };

  return (
    <div className="flex justify-center mt-10">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-4 p-4 border rounded shadow"
      >
        <h2 className="text-xl font-semibold text-center">Edit Admin</h2>

        <div>
          <label className="block font-medium">Email</label>
          <input
            type="email"
            name="Email"
            value={admin.Email}
            onChange={handleChange}
            className="mt-1 p-2 border rounded w-full"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Password</label>
          <input
            type="text"
            name="Password"
            value={admin.Password}
            onChange={handleChange}
            className="mt-1 p-2 border rounded w-full"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default AdminForm;
